import React, { useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ToolTip from '../ToolTipIcon/ToolTip';
import DropDown from '../DropDown/DropDown';
import { launchCreator } from '../../utils/launchCreator';
import { getParent } from '../../utils/parent';

function ShortHandlers(props) {
  const [searchValue, setSearchValue] = useState('');
  const [showUploadDropDown, setShowUploadDropDown] = useState(false);
  const showUploadDropDownTogglerRef = useRef(null);
  const { setShowFolderDialog, setShowUploadDialog } = props;

  const handleSearchButtonClicked = () => {
    const { history } = props;

    if (typeof searchValue !== 'string') {
      return;
    }

    history.push(`/content?search=${searchValue.trim()}`);
  };

  return (
    <div className="flex flex-col md:flex-row ">
      <div className="flex  md:space-x-4 justify-between md:justify-start ">
        <ToolTip toolText="Images" placement="bottom">
          <Link
            role="link"
            aria-label="Images"
            data-test="link-images"
            to="/content?type=image"
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/gallery_icon.svg"
              alt="Images"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTip>

        <ToolTip toolText="Videos" placement="bottom">
          <Link
            role="link"
            aria-label="Videos"
            data-test="link-videos"
            to="/content?type=video"
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/video_icon.svg"
              alt="video icon"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTip>

        <ToolTip toolText="Playlists" placement="bottom">
          <Link
            role="link"
            aria-label="playlists"
            data-test="link-playlists"
            to="/content?type=playlist"
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/table_icon.svg"
              alt="table icon"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTip>

        <ToolTip toolText="Folders" placement="bottom">
          <Link
            role="link"
            aria-label="Folders"
            data-test="link-folders"
            to="/content?type=folder"
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/folder_icon.svg"
              alt="folder icon"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTip>

        <ToolTip toolText="Devices" placement="bottom">
          <Link
            role="link"
            aria-label="Devices"
            data-test="link-devices"
            to="/devices"
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/desktop_icon.svg"
              alt="desktop icon"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </Link>
        </ToolTip>
        <ToolTip toolText="Upload" placement="bottom">
          <div className="flex items-center justify-center flex-col">
            <button
              type="button"
              data-test="content-selector-upload-file"
              className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
              onClick={() => {
                setShowUploadDropDown(false);
                setShowUploadDialog(true);
              }}
            >
              <img
                src="/assets/images/icons/file_upload.svg"
                alt="desktop icon"
                className="w-[30px] h-[30px]"
                draggable={false}
              />
            </button>
          </div>
        </ToolTip>
        <div className="h-[50px] ">
          <button
            aria-label="Upload"
            data-test="add-button"
            ref={showUploadDropDownTogglerRef}
            type="button"
            className="w-[50px] relative cursor-pointer h-[50px]   bg-white rounded-lg"
            onClick={() => {
              setShowUploadDropDown(!showUploadDropDown);
            }}
          >
            <img
              src="/assets/images/icons/upload_icon.svg"
              alt="upload icon"
              className="w-[50px] h-[50px] cursor-pointer"
              draggable={false}
            />
          </button>

          <DropDown
            show={showUploadDropDown}
            hide={() => setShowUploadDropDown(false)}
            togglerRef={showUploadDropDownTogglerRef}
          >
            <div className="relative max-h-[500px] overflow-y-auto md:translate-x-0 -translate-x-1/2">
              <div className="  divide-y divide-gray-200 ">
                <button
                  data-test="new-folder-button"
                  type="button"
                  aria-label="New Folder"
                  className="appearance-none w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100 poppins-regular text-dark-night"
                  onClick={() => setShowFolderDialog(true)}
                >
                  Folder
                </button>
                <button
                  data-test="launch-creator"
                  type="button"
                  className="appearance-none w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100 poppins-regular text-dark-night"
                  onClick={() => {
                    launchCreator(0, getParent(props).id);
                    setShowUploadDropDown(false);
                  }}
                >
                  Sign
                </button>
                <Link
                  to="/sequences/new"
                  className=" poppins-regular text-dark-night flex items-center justify-center w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100"
                >
                  Sequence
                </Link>
                <Link
                  to="/schedules/new"
                  className="poppins-regular text-dark-night flex items-center justify-center  appearance-none w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100"
                >
                  Schedule
                </Link>
                <Link
                  to="/playlists/new"
                  className="poppins-regular text-dark-night flex items-center justify-center  appearance-none w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100"
                >
                  Playlist
                </Link>
                <Link
                  to="/campaigns/new"
                  className="poppins-regular text-dark-night flex items-center justify-center   appearance-none w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100"
                >
                  Campaign
                </Link>
                <button
                  type="button"
                  className="poppins-regular text-dark-night appearance-none w-[200px] h-[40px] rounded-[15px] bg-white hover:bg-gray-100"
                  onClick={() => {
                    setShowUploadDropDown(false);
                    setShowUploadDialog(true);
                  }}
                >
                  Upload Asset
                </button>
              </div>
            </div>
          </DropDown>
        </div>
      </div>

      <div className="flex relative md:mr-0  mt-8 md:mt-0 w-full md:flex-1  justify-end ">
        <div className="h-[50px] w-[80%] bg-[#ffffff] rounded-[15px] flex items-center   md:translate-x-4">
          <img
            src="/assets/images/icons/search_input_icon.svg"
            alt="search icon"
            className="w-[22px] left-[11px] h-[22px] bg-transparent absolute"
            draggable={false}
          />
          <input
            data-test="search-field"
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            type="text"
            placeholder="Search content"
            className="pl-[44px] rounded-[15px]  w-[60%] md:w-full h-full outline-none poppins-regular font-[400] text-[12px] text-[#00243E] "
            onKeyDown={e => {
              if (e.key === 'Enter') {
                handleSearchButtonClicked();
              }
            }}
          />
        </div>
        <div />
        <Link
          data-test="search-link"
          to={`/content?search=${searchValue}`}
          className="bg-[#FF5E00] poppins-bold md:text-md 2xl:text-xl text-sm appearance-none hover:!text-white z-20  w-[20%]  h-[50px] flex items-center justify-center rounded-[15px] poppins-bold font-700 text-white"
        >
          Search
        </Link>
      </div>
    </div>
  );
}

ShortHandlers.propTypes = {
  history: PropTypes.object,
  setShowFolderDialog: PropTypes.func.isRequired,
  setShowUploadDialog: PropTypes.func.isRequired,
};

export default withRouter(ShortHandlers);
